import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { track } from './analytics/track';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Real-visitor page speed (Core Web Vitals). Values are milliseconds, except CLS,
// which is sent x1000 as an integer (0.1 -> 100).
reportWebVitals(({ name, value }) => {
  track('web_vital', { metric: name, value: Math.round(name === 'CLS' ? value * 1000 : value) });
});
